import { createFileRoute, Outlet } from "@tanstack/react-router";

const BaseLayout = () => {
  return (
    <main className="flex min-h-0 flex-1 flex-col bg-canvas px-5 py-8 sm:px-8 sm:py-10">
      <Outlet />
    </main>
  );
};

export const Route = createFileRoute("/_private/(faqs)")({ component: BaseLayout });
